import React from "react";
// import "./styles.css"; // Assuming you've ported CSS to be imported in React
// import botSvg from "./bot.svg";
// import userSvg from "./user.svg";
// import sendSvg from "./send.svg";
// import apiClient, { basePath } from "../../utils/api";
// import Loader from "../Loader/Loader";
// import { Feedback } from "../Feedback/Feedback";
import { IDE } from "./IDE";
// import { Box } from "@mui/material";

interface ChatMessages {
  isAi: boolean;
  content: string;
  typing?: boolean;
  uniqueId?: string;
  imgURLs?: string[];
  comment?: string;
  error: boolean;
}

interface CodeInterpreterProps {
  handleSendMessage: (promptMessage: string) => Promise<void>;
  Messages: ChatMessages[];
  exportCode: (prompt: string) => void;
  pdfInfo: string
}

export const CodeInterpreter: React.FC<CodeInterpreterProps> = ({
  pdfInfo,
  handleSendMessage,
  Messages,
  exportCode,
}) => {
  return (
    <IDE
      pdfInfo={pdfInfo}
      Messages={Messages}
      exportCode={exportCode}
      handleSendMessage={handleSendMessage}
    />
  );
};
